import { StudioVisualizationType } from '@blockworks/platform/api/research/studio/visualizations';

import type { GetVisualizationPropsResponse } from '../../../visualization/models';

const applyParameterGroupParameter = (
    props: Required<GetVisualizationPropsResponse<StudioVisualizationType.Table>>,
) => {
    const { options, meta, params = {}, activeControls, ...rest } = props;

    if (params.groups) {
        options.groups = options.groups.filter(group => {
            return group.name === params.groups;
        });
    }

    return {
        ...rest,
        options,
        meta,
        params,
        activeControls,
    };
};

export { applyParameterGroupParameter };
